import { MobileRedirectParams, MobileStoreRedirect } from 'types/mobile-redirects';
import { apiRequest } from '@utils/request';

export async function appStoreVisitRedirect(params: MobileRedirectParams): Promise<MobileStoreRedirect> {
	const response = await apiRequest.post('/store/visit', params);
	return response.data;
}
